<style lang="scss">
.report-detail-page {
  &__content {
    height: calc(100vh - 200px);
  }

  &__part {
    display: inline-block;
    width: 50%;
    height: 100%;

    &.--left {
      padding-right: 6px;
      padding-left: 12px;
    }

    &.--right {
      padding-right: 12px;
      padding-left: 6px;
      overflow-y: auto;
      vertical-align: top;
    }
  }
}

.fill-width {
  width: 100%;
}
</style>

<template>
  <div class="fill-width fill-height bg-light --scroll">
    <template v-if="getExaminationData">
      <ExaminationInfo
        :examination="getExaminationData.examination"
        :patient="getPatient"
        :examinationTypeList="getExaminationTypeList"
        showStatusButton
        @reportStatusChange="setReportStatus($event)"
      >
        <template #right>
          <v-btn
            color="warning"
            @click="openNhiaDialog()"
          >檢查國健署格式</v-btn>
          <v-btn dark color="teal" class="mr-0" @click="goToReportPreview">
            {{ $t('report_preview.title') }}
          </v-btn>
        </template>
      </ExaminationInfo>
    </template>
    <div class="report-detail-page__content">
      <div class="report-detail-page__part --left">
        <ExaminationForm :id="examinationID" />
      </div>

      <div class="report-detail-page__part --right">
        <screenshots />
      </div>
    </div>
    <report-time :eid="examinationID" />
    <v-dialog v-if="getExaminationData && ishareData" v-model="showNhiaDialog" max-width="800px">
      <NhiaDialog 
        v-if="showNhiaDialog"
        @close="showNhiaDialog = false" 
        :patient="getPatient"
        :examination="getExaminationData.examination"
        :findings="getOrderArticle"
        :ishareData="ishareData"
        :dbIshareData="dbIshareData"
        @checkFinish="checkIshareFormat(true)"
      />
    </v-dialog>
    <v-dialog v-model="showNhiaModifyDialog" width="400">
      <!-- 報告內容有異動，是否要重新填寫國健署表單 -->  
      <v-card>
        <v-card-title>報告內容有異動，是否要重新填寫國健署表單</v-card-title>
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" @click="handleNhiaModify(true)">是</v-btn>
          <v-btn color="error" @click="handleNhiaModify(false)">否</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ExaminationInfo from '../components/ExaminationInfo.vue'
import Screenshots from '../components/report/screenshots'
import ExaminationForm from '../components/report/examination-form.vue'
import ReportTime from '@/components/ReportTime'
import NhiaDialog from '../components/iShareHub/nhiaDialog'
import { reportServices } from '@/services/db'
import { iShareHubRequest, getIshareData, queryIshareData, generateReport, handleIshareDetailData, handleIshareLesionData, deleteIshareData } from "@/services/iShareHub";
// import md5.js
const md5 = require('md5');
 
export default {
  name: 'ReportDetail',
  components: {
    ExaminationInfo,
    Screenshots,
    ExaminationForm,
    ReportTime,
    NhiaDialog,
  },
  updated() {
    if (Number(this.getExaminationData.examination.reportStatus) == 0) {
      this.setReportStatus('Editing')
    }
  },
  async mounted(){
    
  },
  async created() {
    this.$store.dispatch('examinations/resetStoreHiddenParameter')
    this.$store.dispatch('examinations/resetQuestionsList')

    this.$store.dispatch('examinations/fetchExaminationDetailAndOtherList', {
      examinationID: this.examinationID,
      accNo: this.accNo,
    }).then(r => {
      if (this.getSetting.descriptive) {
        this.fetchDescriptiveParagraph({
          eid: r.data.examination.id,
          etype: r.data.examination.examination_typeID,
        })
      }
    })
    this.$store.dispatch('examinations/fetchOrderArticle', {
      examinationID: this.examinationID,
    })
  },

  data() {
    return {
      ishareData: null,
      dbIshareData: {},
      dropdownItems: {
        reportStatus: ['Unedited', 'Editing', 'Finalized'],
        reportStatusColors: {
          Unedited: 'primary',
          Editing: 'orange',
          Finalized: 'green',
        },
      },
      showNhiaDialog: false,
      showNhiaModifyDialog: false,
    }
  },

  computed: {
    ...mapGetters(['getSetting']),
    ...mapGetters('examinations', [
      'getExaminationData',
      'getExaminationTypeList',
      'getPatient',
      'getOrderArticle'
    ]),
    getFindings() {
      return this.getExaminationData ? this.getExaminationData.findings : null
    },
    examinationID() {
      if (Number(this.$route.params.examinationID) != 0) {
        return this.$route.params.examinationID
      } else {
        if (this.getExaminationData != null) {
          return this.getExaminationData.examination.id
        }
      }
    },

    accNo() {
      return Number(this.$route.params.accNo) != 0
        ? this.$route.params.accNo
        : 0
    },

    examType() {
      if (this.getExaminationData) {
        return this.getExaminationData.examination.examination_typeID
      }
      return 0
    },
  },

  methods: {
    ...mapActions('examinations', [
      'updateExaminationColumn',
      'addExaminationSedative',
      'deleteExaminationSedative',
      'fetchDescriptiveParagraph',
    ]),
    async handleNhiaModify(value){
      if(value){
        console.log('detail_id', this.dbIshareData.detail.detail_id)
        await deleteIshareData(this.dbIshareData.detail.detail_id)
        this.dbIshareData = {}
      }
      this.showNhiaModifyDialog = false
      this.showNhiaDialog = true
    },
    async openNhiaDialog() {
      const res2 = await getIshareData(this.examinationID)
      let currentMd5Content = ''
      let newMd5Content = ''
      const res = await queryIshareData(this.examinationID)
      if(res){
        const queryData = {
          detail: handleIshareDetailData(res, this.getPatient, this.getExaminationData.examination, true), 
          lesion: handleIshareLesionData(res.findings_data, this.getOrderArticle, true, res.LesionA)
        }
        console.log('queryData', md5(JSON.stringify(queryData)), JSON.stringify(queryData))
        newMd5Content = md5(JSON.stringify(queryData))
      }
      this.ishareData = {
        ...res,
        Exam_date: res.Exam_date.replace(/-/g, ''),
        Patient_birth: res.Patient_birth.replace(/-/g, ''),
        exam_id: this.examinationID
      }
      console.log('this.ishareData', this.ishareData)
      if(res2 && res2.md5_code !== ''){
        this.dbIshareData = res2
        currentMd5Content = res2.md5_code
        //已經按過 save
        console.log('currentMd5Content', currentMd5Content)
        console.log('newMd5Content', newMd5Content)
        if(currentMd5Content !== newMd5Content){
          // 確認是否有編輯過
          this.showNhiaModifyDialog = true
          return
        }
      }
      console.log('dbIshareData', this.dbIshareData)
      this.showNhiaDialog = true
      this.checkIshareFormat()
    },
    popupSnackbar(message, color = 'error', timeout = 3000) {
      this.$store.dispatch('snackBar/trigger', {
        message,
        color,
        timeout
      })
    },
    async handleIshareErrors(validResults, flagGenerateReport = false){
      let _errors = []
      if (validResults.length > 0) {
        for (const result of validResults) {
          if (result.status === '失敗') {
            _errors.push(...result.errors)
          }
        }
      }
      if (_errors.length > 0) {
        this.popupSnackbar(_errors.join('\n'), 'error', 10000)
      } else {
        this.popupSnackbar('格式正確', 'success', 3000)
        if(flagGenerateReport){
          const generateResult = await generateReport(this.examinationID)
          if (!generateResult.success) {
            this.popupSnackbar('生成報告失敗', 'error', 3000)
          }
        }
      }
      return _errors
    },
    async checkIshareFormat(flagGenerateReport = false) {
      const res = await iShareHubRequest({examId: [this.examinationID], validateOnly: true})
      
      if (!res.success) {
        this.popupSnackbar(res?.message || '格式錯誤', 'error')
      }else {
        const validResults = res.data.validation_results
        return this.handleIshareErrors(validResults, flagGenerateReport)
      }
    },
    async downloadReport(reportData){
      const data = reportData.data
      if(!data.content){
        this.$store.dispatch('snackbar/showSnackbar', { text: 'No data available!', color: 'error' })
        return
      }
      // 將data.content 用base64解碼
      const decodedContent = atob(data.content);
      // 將解碼後的XML字串寫入檔案
      const blob = new Blob([decodedContent], { type: 'text/xml' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = data.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    uploadScreenshot() {
      if (
        document
          .getElementById('uploadScreenshotButtonA')
          .innerHTML.split('Uploaded').length == 1
      ) {
        this.$store
          .dispatch('examinations/notificationUniGateUploadScreenshot', {
            examinationID: this.examinationID,
          })
          .then(() => {
            document.getElementById('uploadScreenshotButtonA').style =
              'display: none;'
            document.getElementById('uploadScreenshotButtonB').style =
              'background-color: green; color: #fff;'
            setTimeout(function () {
              document.getElementById('uploadScreenshotButtonA').style =
                'background-color: #EA7500; color: #ffffff;'
              document.getElementById('uploadScreenshotButtonB').style =
                'display: none;'
            }, 3000)
          })
      }
    },

    goToPrint() {
      this.$router.push({
        path: `/reports/${this.examinationID}/accNo/0/print`,
      })
    },

    goToHome() {
      this.$router.push({
        path: `/home`,
      })
    },

    setReportStatus(item) {
      const value = this.dropdownItems.reportStatus.indexOf(item)
      console.log(`setReportStatus: ${item}, value: ${value}`)
      this.setExaminationColumn('reportStatus', value)
      // Finalized
      /* if (
        value === 2 &&
        Number(this.getExaminationData.examination.examination_typeID) === 2
      ) {
        this.reportHPA()
      }
      if (
        value === 2 &&
        Number(this.getExaminationData.examination.examination_typeID) === 1
      ) {
        this.reportHIS()
      } */
      if (item === 'Finalized') {
        this.sendReport()
      }
    },

    sendReport() {
      reportServices.sendSRReport(Number(this.examinationID), this.examType);
    },

    reportHPA() {
      console.log(
        `====== report HPA ======> examinationId: ${Number(
          this.examinationID,
        )}, worklistId: ${this.getExaminationData.examination.accNo}`,
      )
      reportServices.uploadHPAReport({
        examinationId: Number(this.examinationID),
        worklistId: this.accNo,
      })
    },

    reportHIS() {
      console.log(
        `====== report HIS ======> examinationId: ${Number(
          this.examinationID,
        )}, worklistId: ${this.getExaminationData.examination.accNo}`,
      )
      reportServices.uploadHISReport({
        examinationId: Number(this.examinationID),
        worklistId: this.accNo,
      })
    },

    bowelCleanseFormChange(obj) {
      var value = obj.event
      const timeFiled = [
        'insertionTime',
        'proximalColonWithTime',
        'withdrawTime',
        'totalExamTime',
      ]
      const reg = '([0-1][0-9]|2[0-3])\:[0-5][0-9]\:[0-5][0-9]'
      const regExp = new RegExp(reg)

      if (obj.field == 'antiplateletStopDays') {
        value = parseInt(obj.event, 10)
      } else if (timeFiled.includes(obj.field) && !regExp.test(value)) {
        value = '00:00:00'
      }

      this.setExaminationColumn(obj.field, value)
    },

    setExaminationColumn(column, value) {
      let d = {
        id: this.examinationID,
        column: column,
        value: value,
      }
      this.updateExaminationColumn(d)
    },

    handleSedative(action, event) {
      const examinationSedativeID = event ? event.id : null
      this[`${action}ExaminationSedative`]({
        examinationID: this.examinationID,
        examinationSedativeID,
      })
    },
    goToReportPreview() {
      this.$router.push(
        `/reports/${this.examinationID}/accNo/${this.accNo}/preview`,
      )
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/pages/page_reportDetail.scss';
</style>